import { Buffer } from 'buffer';
import { currentEnvironment, ENVIRONMENTS } from '../runtime-config';

function getRequiredLocalAemEnv(name: string) {
  const value = process.env[name]?.trim();
  if (!value) {
    throw new Error(
      `${name} must be set when NEXT_PUBLIC_ENVIRONMENT_NAME=local. See .env.example for local AEM credentials.`,
    );
  }

  return value;
}

export function getAemHeaders() {
  const headers = new Headers();

  if (currentEnvironment === ENVIRONMENTS.LOCAL) {
    const username = getRequiredLocalAemEnv('AEM_LOCAL_USERNAME');
    const password = getRequiredLocalAemEnv('AEM_LOCAL_PASSWORD');

    headers.append(
      'Authorization',
      'Basic ' + Buffer.from(username + ':' + password).toString('base64'),
    );
    headers.append('Cookie', 'cq-authoring-mode=TOUCH');
  }

  return headers;
}
